// src/services/streams/streamApi.ts

import baseApi from "../../lib/baseApi";

import type {
  StreamMode,
  StreamResponse,
  StreamScope,
  SupportedStreamKind,
} from "../../types/streams/streamTypes";

const ROOT = "/streams";

// ------------------------------------------------------------
// Cursor helper
// Backend universal stream returns token like:
// 2026-05-27T...|123
// Keep full URLs safe too, in case backend changes later.
// ------------------------------------------------------------
const normalizeCursor = (cursor?: string | null) => {
  if (!cursor) return undefined;

  const trimmed = String(cursor).trim();
  if (!trimmed) return undefined;

  if (trimmed.includes("://") || trimmed.includes("?cursor=")) {
    try {
      const u = new URL(trimmed, window.location.origin);
      return u.searchParams.get("cursor") || undefined;
    } catch {
      const m = trimmed.match(/[?&]cursor=([^&]+)/);
      return m?.[1] ? decodeURIComponent(m[1]) : undefined;
    }
  }

  return trimmed;
};

// ------------------------------------------------------------
// API
// ------------------------------------------------------------
export const streamApi = {
  fetch: async (opts: {
    kind: SupportedStreamKind;
    seedId: number;
    scope?: StreamScope;
    mode?: StreamMode;
    cursor?: string | null;
    extension?: number;
    username?: string | null;
  }) => {
    const cursorToken = normalizeCursor(opts.cursor);

    const { data } = await baseApi.get<StreamResponse>(`${ROOT}/`, {
      params: {
        kind: opts.kind,
        seed_id: opts.seedId,
        scope: opts.scope ?? "square",
        mode: opts.mode ?? "related",
        cursor: cursorToken,
        ext: opts.extension ?? 0,
        username: opts.username || undefined,
      },
    });

    return data;
  },
};

export default streamApi;